import Model from './Model'
import {File} from "./";
export default class Directory extends Model {

    static async create(filesystemId, name, subDirectoryId){
        const {data} = await Http.post(route('api.v1.directories.create'), {
            filesystem: filesystemId,
            directory: subDirectoryId,
            name: name
        })

        return Directory.make(data.data)
    }

    getPreviewObject(){
        return {
            name: this.name,
            previewable: false,
            type: 'directory',
            icon: '',
            previewUrl: '',
            downloadUrl: '',
            deleteUrl: this._links.delete,
            createdAt: this.created_at,
            createdBy: this.created_by,
            size: this.count,
        }
    }
    static async get(directoryId) {
        const {data} = await Http.get(route('api.v1.directories.show', directoryId))

        const directoryData = data

        if (data.files.data.length) {
            directoryData.files = data.files.data.map(file => {
                return File.make(file)
            })
        }

        if (data.directories.data.length) {
            directoryData.directories = data.directories.data.map(file => {
                return Directory.make(file)
            })
        }

        return directoryData
    }

}
